<form name="loginForm" novalidate (ngSubmit)="forward()" autocomplete="off" [ngClass]="{'form-complete': isFormCompleted}">
    <mat-form-field class="w-100">
        <mat-label for="login-new-input">{{ 'copy.label.LOGIN.attendeeType' | copy | async }}</mat-label>
        <mat-select name="login-new-input" id="login-new-input" aria-label="login-new-input"
          [(ngModel)]="loginID" matNativeControl required>
          <mat-option *ngFor="let obj of attendeeTypes" [value]="obj.code">{{ obj.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    <!-- <mat-form-field class="w-100" ng-if="loginCtrl.programInfo.regCode">
        <mat-label [ngClass]="{'active' : regcode}" for="regcode">{{"copy.label.LOGIN.regcode.label"|copy|async}}</mat-label>
        <input matInput type="text" name="regcode" id="regcode" aria-label="Registration/Promo code" [(ngModel)]="regcode" alphanum />
    </mat-form-field> -->
    <div class="button_group d-flex">
        <!-- <button aria-label="Decline" class="back btn btn-outline-primary" type="button" (click)="declineButtonClick( )" *ngIf="!isSubmitting">Decline</button>
        <button class=" inputSubmit btn btn-primary ml-auto" *ngIf="isSubmitting">
            <i class="fas fa-spinner fa-spin"></i>
        </button> -->
        <a href="http://www.osaicconnected.com/" ><button aria-label="Decline" class="forward btn btn-primary" type="button" *ngIf="!isSubmitting">{{'copy.label.LOGIN.newlogin.homebutton'|copy|async}}</button></a>
        <button *ngIf="!isSubmitting" name="new-login-button" type="submit" aria-label="Submit" class="forward btn btn-primary">{{'copy.label.LOGIN.newlogin.button'|copy|async}}</button>
    </div>
    <span class="help-block"><a tabindex="0" (click)="openModal('LoginRegHelp', 'Registration Help', 'Close')" (keydown.enter)="openModal('LoginRegHelp', 'Registration Help', 'Close')">{{"copy.label.LOGIN.newlogin.help"|copy|async}}</a></span>

    <div *ngIf="errorMsg" type="danger">
        <strong>
            <span class="fas fa-stack">
            <i class="fas fa-exclamation fa-stack-1x"></i>
            <i class="far fa-circle fa-stack-2x"></i>
            </span>
            {{errorMsg}}
        </strong>
    </div>
</form>